/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {WealthyEnv} from "helpers";

const headingTagIcon = `${WealthyEnv.BROKING_CDN_URL}/heading-tag.png`;

const SectionTitle = ({hasTag, children}) => {
  return (
    <SectionHeading className={hasTag ? "hasTag" : ""}>{children}</SectionHeading>
  );
};

const SectionHeading = styled.h2`
  font-size: 3.2rem;
  position: relative;

  &.hasTag {
    padding-left: 94px;

    &::before {
      content: "";
      position: absolute;
      top: -30%;
      left: 0;
      height: 82px;
      width: 82px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(${headingTagIcon});
    }
  }

  @media (max-width: 576px) {
    font-size: 1.6rem;

    &.hasTag {
      padding-left: 52px;

      &::before {
        top: -40%;
        height: 46px;
        width: 46px;
      }
    }
  }
`;

export default SectionTitle;
